import React, { useState } from 'react';
import { connect } from 'redux-scaffolding-ts';
import TailwindNewSupportDetailsComponent from 'site/pages/requests/shared-wizard-form/request-new-support-details.component-tw';
import TailwindSupportDetailsComponent from 'site/pages/requests/shared-wizard-form/request-support-details.component-tw';
import { RequestFormStore, RequestFormViewModel } from 'stores/requests/request-form-store';
import { SupportDetails } from 'stores/requests/requests-store';

interface RequestSupportDetailsContainerProps {
  request?: RequestFormViewModel;
  readOnly: boolean;
  requestFormStore?: RequestFormStore;
  onChange?: (value: Partial<RequestFormViewModel>) => void;
}

const RequestSupportDetailsContainer: React.FC<RequestSupportDetailsContainerProps> = ({
  request,
  readOnly,
  requestFormStore,
  onChange
}) => {
  const [selectedRequest /*, setSelectedRequest*/] = useState<RequestFormViewModel>(request);
  const { supportDetails, startDate, endDate, requestingLocation, eventTypeName } = selectedRequest;

  const handleOnSupportDetailsChange = (change: Partial<SupportDetails>) => {
    onChange && onChange({ supportDetails: { ...supportDetails, ...change } });
  };

  return (
    <div className="space-y-4">
      {!supportDetails.isNewSupportPositionModel && (
        <TailwindSupportDetailsComponent
          startDate={startDate}
          endDate={endDate}
          supportDetails={supportDetails}
          onChange={handleOnSupportDetailsChange}
          isForm
          readOnly={readOnly}
        />
      )}
      {supportDetails.isNewSupportPositionModel && (
        <TailwindNewSupportDetailsComponent
          startDate={startDate}
          endDate={endDate}
          supportDetails={supportDetails}
          onChange={handleOnSupportDetailsChange}
          isForm
          readOnly={readOnly}
          requestLocationId={requestingLocation.id}
          eventTypeName={eventTypeName}
        />
      )}
    </div>
  );
};

export default connect(['requestFormStore', RequestFormStore])(RequestSupportDetailsContainer);
